export default __webpack_public_path__ + "static/media/time-ico.1809a815.svg";